import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "student-tutoring-dashboard" */ './StudentTutoringCtnr'));
export const StudentTutoringDashboardPage = Loadable(
  () => import(/* webpackChunkName: "student-tutoring-dashboard" */ './StudentTutoringDashboardPage'),
);
